// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

$( '.search-toggle' ).click(function() {
  $( '.search-form' ).toggleClass( 'searching');
});

$( '.menu-toggle a' ).click(function() {
  $( 'nav.nav-primary, #search' ).slideToggle( 'slow', function() {
  });
});
$('.desc-toggle.btn').on('click', function() {
  $(this).siblings('.desc').fadeToggle('slow');
    });

// gsap animations

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

//menu
const showAnim = gsap.from('header.banner', { 
  yPercent: -150,
  paused: true,
  duration: 0.2,
}).progress(1);

ScrollTrigger.create({
  start: 'top -100',
  end: 99999,
  onUpdate: (self) => {
    self.direction === -1 ? showAnim.play() : showAnim.reverse()
  },
});

// Responsive Actions

$(document).ready(function(){

  var width = $(window).width();
  
     if (width <= 768){
       
      // mobile
      
      gsap.to('section.one h3', {

        scrollTrigger: {
          trigger: 'section.one h3',
          pin: 'section.one h3', 
          start: 'top 180px',
          end: 360,
          scrub: 1, 
          pinSpacing: false,
          markers: false,
        },
      });
      
     }

     
     else {

      // desktop

      gsap.to('#big-list h2', {
        y: 500,
        duration: 1200,
          scrollTrigger: {
            trigger: '#big-list',
            start: 'center 50%',
            end: 'bottom 50%',
            scrub: 1, 
            pinSpacing: false,
            markers: false,
          },
        });

        gsap.to('section.one h3', {
          scrollTrigger: {
            trigger: 'section.one h3',
            pin: 'section.one h3', 
            start: 'top 160px',
            end: 2080,
            scrub: 1, 
            pinSpacing: false,
            markers: false,
          },
        });
        
        gsap.to('section.two h3', {
          scrollTrigger: {
            trigger: 'section.two h3',
            pin: 'section.two h3',
            start: 'top 280px',
            end: 2080,
            scrub: 1, 
            pinSpacing: false,
            markers: false,
          },
        });

    
        
     }
});

  // Images

  gsap.utils.toArray('img.grow-up').forEach(images => {
    gsap.fromTo(images, {
     clipPath: 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)',
   }, { 
     scrollTrigger: {
       trigger: images,
       scrub: 1,
       start: 'center 100%',
       end: 'center 80%',
       markers: false,
     },
     clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
   });
   })

   //content blocks

   gsap.utils.toArray('.col.push').forEach(push => {
    gsap.to(push, {
  
     scrollTrigger: {
       trigger: push,
       scrub: 1,
       start: 'top 80%',
       end: 'bottom 80%',
       markers: false,
     },
     y: -80,
     duration: 3,
   });
   })

   gsap.utils.toArray('.col.pull').forEach(pull => {
    gsap.from(pull, {
  
     scrollTrigger: {
       trigger: pull,
       scrub: 1,
       start: 'top 80%',
       end: 'bottom 80%',
       markers: false,
     },
     y: 100,
     duration: 3,
   });
   })


   


// Load Events
jQuery(document).ready(() => routes.loadEvents());




// WEBPACK FOOTER //
// ./scripts/main.js